<template>
  <tabs centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-nav-classes="icon-white" tab-content-classes="tab-content-padding tab-no-space ">
    <tab-pane>
      <template slot="label">
        <i class="fa fa-user" />
      </template>

      <tabs type="primary" centered class="patient-history-tabs" tab-nav-wrapper-classes="p-0" tab-content-classes="patient-history-tab-content">
        <!-- Bio -->
        <tab-pane label="Bio" v-if="patient">
          <template slot="label">
            <span>{{ $t("message.Bio") }}</span>
          </template>
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <profile-image :file-id="patient.profileImage" image-style="width: 100px; height: 100px; border-radius: 50%">
                </profile-image>
              </div>
              <div class="col-12 text-center mt-3">
                {{ patient.patientId }}
                <h6 class="mt-2">
                  {{ patient.firstName }} {{ patient.lastName }}
                </h6>
                {{ getAge(patient.dob) }}
                <br />
                <div style="font-size: 30px">
                  <span v-if="patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                    <i class="fa fa-mars"></i>
                  </span>
                  <span v-if="patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                    <i class="fa fa-venus"></i>
                  </span>
                  <span v-if="patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                    <i class="fa fa-transgender-alt"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <!-- Vitals history -->
        <tab-pane label="Vitals">
          <template slot="label">
            <span @click="getVitalHistory()">{{ $t("message.Vitals") }}</span>
          </template>
          <div class="col-12" style="height:100%">
            <div class="row" style="height: 100%; overflow: scroll">
              <div class="col-md-6 col-lg-4" v-for="(device, index) in deviceProfile" :key="device.identifier" :id="device.identifier">
                <vital-card :deviceforcard="device" :vitals="vitals" :vital-index="index" ref="vitalComponents" @vital-validated="
                          vitalBtnDisabled = true & shareVitals()
                        " :historic-vitals="historicVitals" :error-messages="errorMessages" :allowManualEntry="false" :allowRetrieval="false"></vital-card>
              </div>
            </div>
          </div>
        </tab-pane>

        <!-- Files history -->
        <tab-pane label="Files">
          <template slot="label">
            <span>{{ $t("message.Files") }}</span>
          </template>
          <div class="col-12">
            <div style="height: 38em; overflow: scroll">
              <div class="col-12 mt-5 text-center" v-if="!historicFiles || historicFiles.length < 1">
                {{ $t("message.No files for the patient") }}
              </div>
              <div class="col-12 file-list" v-for="(file, index) in historicFiles" :key="index">
                <div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-2 col-md-2 col-lg-2">
                        <div v-if="file.type.indexOf('image') > -1">
                          <dynamic-image :file-id="file.fileId" image-style="min-height: 20px; width: 100%">
                          </dynamic-image>
                        </div>
                        <div v-else-if="file.type.indexOf('pdf') > -1">
                          <i class="fa fa-file-pdf" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else-if="file.type.indexOf('video') > -1">
                          <i class="fa fa-file-video" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else-if="file.type.indexOf('audio') > -1">
                          <i class="fa fa-file-audio" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else>
                          <i class="fa fa-file" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                      </div>
                      <div class="col-8 col-md-8 col-lg-8" @click="viewFile(file)">
                        <p class="card-heading">{{ file.name }}</p>
                        <p class="card-heading file-date">
                          {{ getFormattedDate(file.created) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <!-- Prescription history -->
        <tab-pane label="Notes">
          <template slot="label">
            <span>{{ $t("message.Notes") }}</span>
          </template>
          <div class="col-12 content-inner" v-loading="DOWNLOADING_PRESCRIPTION" :element-loading-text="$t('message.Getting your prescription')">
            <div v-if="historicPrescriptions" style="height: 38em; overflow: scroll">
              <div class="row">
                <div class="col-12 col-lg-3" v-if="!selectedPrescription">
                  <!-- List for extra small devices -->
                  <div class="row d-block d-md-block d-lg-none">
                    <div class="col-12 prescription-list" v-for="prescription in historicPrescriptions" :key="prescription._id">
                      <div @click="viewPrescription(prescription)">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-2 col-md-1 col-lg-3">
                              <i class="el-icon-tickets prescription-icon"></i>
                            </div>
                            <div class="col-10 col-md-11 col-lg-9">
                              <p class="card-heading reason">
                                {{ prescription.reason }}
                              </p>
                              <p class="card-heading mb-0">
                                {{ $t("message.Dr") }}.
                                {{ prescription.provider.firstName }}
                                {{ prescription.provider.lastName }}
                              </p>
                              <p class="card-heading">
                                {{
                                        getFormattedDate(prescription.created)
                                      }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="historicPrescriptions.length < 1" class="col-12 text-center">
                      <i class="fa fa-info-circle"></i>
                      {{ $t("message.No Prescriptions available") }}
                    </div>
                  </div>
                </div>

                <div v-if="selectedPrescription">
                  <n-button type="primary" round @click.native="selectedPrescription = null" icon style="position: absolute; z-index: 1; top:-7%;">
                    <i class="now-ui-icons arrows-1_minimal-left"></i>
                  </n-button>
                  <card>
                    <prescription :prescription="
                              selectedPrescription.prescriptions[0]
                                .prescriptions
                            " v-if="
                              selectedPrescription.prescriptions[0]
                                .prescriptions
                            " :appointment="selectedPrescription" :editable="false"></prescription>
                    <n-button type="primary" round style="margin-left: 15px" @click.native="downloadPrescription()" v-if="HAS_PRESCRIPTION && !IsCareCoordinator">
                      <i class="fa fa-print"></i>
                      {{ $t("message.Download Prescription") }}
                    </n-button>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </tab-pane>
  </tabs>
</template>

<script>
import { TabPane, Tabs } from "src/components";
import vitalCard from "@/pages/carenation/components/VitalCard";
import PrescriptionService from "../../../services/prescription.js";
import moment from "moment-timezone";
export default {
  name: "patienthistory",
  components: {
    TabPane,
    Tabs,
    vitalCard,
  },
  data() {
    return {
      patient: null,
      FETCHED_HISTROIC_VITALS: false,
      deviceProfile: [],
      vitals: {
        deviceData: {},
      },
      historicVitals: null,
      errorMessages: {},
      historicFiles: [],
      loader: null,
      DOWNLOADING_PRESCRIPTION: false,
      historicPrescriptions: [],
      selectedPrescription: null,
      endpoint: null,
      IsCareCoordinator: false,
    };
  },
  computed: {
    previewLink() {
      return this.baseUrl + "/file/";
    },
    appointment() {
      return this.$store.state.appointment;
    },
    HAS_PRESCRIPTION() {
      let prescriptions =
        this.selectedPrescription.prescriptions[0].prescriptions;
      return PrescriptionService.hasPrescription(prescriptions);
    },
  },

  methods: {
    async getVitalHistory() {
      if (!this.FETCHED_HISTROIC_VITALS) {
        try {
          this.historicVitals = await this.$store.dispatch("getVitalHistory", {
            patientId: this.patient.patientId,
            deviceProfile: this.deviceProfile,
            fromTime: moment().subtract(30, "days").unix() * 1000,
            toTime: moment().unix() * 1000,
          });
          this.FETCHED_HISTROIC_VITALS = true;
        } catch (e) {
          console.log(e);
        }
      }
    },
    async viewFile(file) {
      let that = this;
      try {
        that.loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        //get file from server
        let fileArrayBuffer = await this.$store.dispatch(
          "getFile",
          file.fileId
        );

        let pdfBlob = new Blob([fileArrayBuffer]);

        let storageLocation = "";

        if (typeof device !== "undefined") {
          switch (device.platform) {
            case "Android":
              storageLocation = cordova.file.externalDataDirectory;
              break;

            case "iOS":
              storageLocation = cordova.file.documentsDirectory;
              break;
          }

          let folderPath = storageLocation;

          window.resolveLocalFileSystemURL(
            folderPath,
            function (dir) {
              dir.getFile(
                file.name,
                {
                  create: true,
                },
                function (file) {
                  file.createWriter(
                    function (fileWriter) {
                      fileWriter.write(pdfBlob);

                      fileWriter.onwriteend = function () {
                        var url = file.nativeURL;
                        cordova.plugins.fileOpener2.open(url, pdfBlob.type, {
                          error: function error(err) {
                            console.error(err);
                            that.loader.hide();
                            alert(this.$t("message.Unable to download"));
                          },
                          success: function success() {
                            that.loader.hide();
                            console.log("success with opening the file");
                          },
                        });
                      };

                      fileWriter.onerror = function (err) {
                        that.loader.hide();
                        alert(this.$t("message.Unable to download"));
                        console.error(err);
                      };
                    },
                    function (err) {
                      that.loader.hide();
                      // failed
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.loader.hide();
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            },
            function (err) {
              that.loader.hide();
              alert(this.$t("message.Unable to download"));
              console.error(err);
            }
          );
        }
      } catch (e) {
        that.loader.hide();
        console.log(e);
      }
    },
    downloadPrescription() {
      let that = this;
      that.DOWNLOADING_PRESCRIPTION = true;
      let prescriptionDate = null;
      if (this.selectedPrescription.prescriptions[0].created) {
        prescriptionDate = this.selectedPrescription.prescriptions[0].created;
      }
      if (window.cordova) {
        PrescriptionService.getDataURL(
          this.appointment,
          this.selectedPrescription.prescriptions[0].prescriptions,
          prescriptionDate,
          {},
          (dataUrl) => {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            var byteString = atob(dataUrl.split(",")[1]);

            // separate out the mime component
            var mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer(byteString.length);

            // create a view into the buffer
            var ia = new Uint8Array(ab);

            // set the bytes of the buffer to the correct values
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }

            // write the ArrayBuffer to a blob, and you're done
            var pdfBlob = new Blob([ab], { type: mimeString });

            let storageLocation = "";

            if (typeof device !== "undefined") {
              switch (device.platform) {
                case "Android":
                  storageLocation = cordova.file.externalDataDirectory;
                  break;

                case "iOS":
                  storageLocation = cordova.file.documentsDirectory;
                  break;
              }

              let folderPath = storageLocation;

              window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                  dir.getFile(
                    "prescription",
                    {
                      create: true,
                    },
                    function (file) {
                      file.createWriter(
                        function (fileWriter) {
                          fileWriter.write(pdfBlob);

                          fileWriter.onwriteend = function () {
                            var url = file.nativeURL;
                            cordova.plugins.fileOpener2.open(
                              url,
                              pdfBlob.type,
                              {
                                error: function error(err) {
                                  console.error(err);
                                  that.DOWNLOADING_PRESCRIPTION = false;
                                  alert(this.$t("message.Unable to download"));
                                },
                                success: function success() {
                                  that.DOWNLOADING_PRESCRIPTION = false;
                                  console.log("success with opening the file");
                                },
                              }
                            );
                          };

                          fileWriter.onerror = function (err) {
                            that.DOWNLOADING_PRESCRIPTION = false;
                            alert(this.$t("message.Unable to download"));
                            console.error(err);
                          };
                        },
                        function (err) {
                          that.DOWNLOADING_PRESCRIPTION = false;
                          // failed
                          alert(this.$t("message.Unable to download"));
                          console.error(err);
                        }
                      );
                    },
                    function (err) {
                      that.DOWNLOADING_PRESCRIPTION = false;
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.DOWNLOADING_PRESCRIPTION = false;
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            }
          }
        );
      } else {
        PrescriptionService.download(
          this.appointment,
          this.selectedPrescription.prescriptions[0].prescriptions,
          prescriptionDate,
          {}
        );
      }
    },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    async viewPrescription(prescription) {
      let appointment = await this.$store.dispatch(
        "getAppointment",
        prescription.prescriptions[0].appointmentId
      );
      this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appointment,
      });
      // route to prescription page
      this.$router.push(
        "/viewhistoricprescription/" + prescription.prescriptions[0]._id
      );
    },
  },

  async mounted() {
    try {
      this.patient = await this.$store.dispatch(
        "getPatientByPatientId",
        this.$store.state.patientId
      );
    } catch (e) {
      console.log(e);
    }

    if (this.user.roles.indexOf("careCoordinator") > -1) {
      this.IsCareCoordinator = true;
    }

    try {
      let patientEp = null;
      for (let ep of this.patient.endpoints) {
        if (ep.isDefault && ep.name) {
          patientEp = ep.name;
          break;
        }
      }
      this.endpoint = await this.$store.dispatch("getEndpoint", patientEp);

      //get device profile from configurations
      let response = await this.$store.dispatch(
        "getConfigurationByEndpointId",
        {
          endpointId: this.endpoint._id,
          type: "deviceProfile",
        }
      );
      if (response && response.value) {
        this.deviceProfile = response.value;
      }
    } catch (e) {
      console.log(e);
    }

    try {
      this.historicFiles = (
        await this.$store.dispatch("getFilesHistory", this.patient.patientId)
      ).data;
    } catch (e) {
      console.log(e);
    }

    try {
      this.historicPrescriptions = (
        await this.$store.dispatch("getPrescriptionsHistory", {
          patientId: this.patient.patientId,
        })
      ).data;
    } catch (e) {
      console.log(e);
    }
  },
};
</script>

<style scoped>
/deep/ .patient-history-tabs .nav-pills .nav-item .nav-link {
  min-width: 75px !important;
}

/deep/ .nav-pills .nav-item .nav-link {
  min-width: 110px !important;
}

/deep/ .patient-history-tabs a.nav-link {
  font-size: 13px;
}
/deep/ .patient-history-tabs {
  height: 100%;
}
/deep/ .tab-content.patient-history-tab-content {
  height: 100%;
}
/deep/ .tab-content {
  height: calc(100% - 68px);
}
.content > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  padding-top: 1em;
}

.prescription-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}
.prescription-list:first-child {
  border-top: none;
}
.prescription-list.selected {
  background-color: whitesmoke;
}
.prescription-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}
.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}
</style>
